import { useCallback, useEffect, useState } from 'react'
import useEmblaCarousel from 'embla-carousel-react'
import style from '@/sections/about-cards/about-cards.module.scss'

export function useTimeLineCarousel(container: string, direction: 'ltr' | 'rtl') {
  const [selectedIndex, setSelectedIndex] = useState(0)
  const [emblaMainRef, emblaMainApi] = useEmblaCarousel({
    container,
    loop: false,
    direction,
  })
  const [emblaThumbsRef, emblaThumbsApi] = useEmblaCarousel({
    align: 'start',
    direction,
    container: `.${style.container}`,
    breakpoints: {
      '(min-width: 1024px)': { active: false },
      '(max-width: 768px)': { align: 'center' },
    },
  })

  const onThumbClick = useCallback(
    (index: number) => {
      if (!emblaMainApi || !emblaThumbsApi) return
      emblaMainApi.scrollTo(index)
    },
    [emblaMainApi, emblaThumbsApi]
  )

  const onSelect = useCallback(() => {
    if (!emblaMainApi || !emblaThumbsApi) return
    setSelectedIndex(emblaMainApi.selectedScrollSnap())
    emblaThumbsApi.scrollTo(emblaMainApi.selectedScrollSnap())
  }, [emblaMainApi, emblaThumbsApi, setSelectedIndex])

  const onPrevButtonClick = useCallback(() => {
    if (!emblaMainApi) return
    emblaMainApi.scrollPrev()
  }, [emblaMainApi])

  const onNextButtonClick = useCallback(() => {
    if (!emblaMainApi) return
    emblaMainApi.scrollNext()
  }, [emblaMainApi])

  useEffect(() => {
    if (!emblaMainApi) return
    onSelect()

    emblaMainApi.on('select', onSelect).on('reInit', onSelect)
  }, [emblaMainApi, onSelect])

  return {
    onThumbClick,
    emblaThumbsRef,
    emblaMainRef,
    onNextButtonClick,
    onPrevButtonClick,
    selectedIndex,
  }
}
